<template>
  <div
    class="extra-guarantee font-normal"
    data-testid="extraGuaranteeInner"
  >
    <div class="flex flex-col gap-2 lg:gap-4">
      <CartSection :title="$t('Item added to your cart!')">
        <ExtraGuaranteeSidebarProduct
          :product-name="productName"
          :product-image="productImage"
        />
      </CartSection>
      <CartSection :title="$t('Choose the protection package')">
        <ExtraGuaranteeOptions
          :extra-guarantee-sku="extraGuaranteeSku"
          @update:selected-option="$emit('update:selectedOption', $event)"
        />
        <div class="text-sm">
          <p>
            {{ $t('extra-guarantee.details.a') }}
          </p>
          <br>
          <ul class="list-none flex flex-col gap-4">
            <li class="flex gap-2">
              <span class="mt-0.25 text-lg shrink-0 iconify fa-pro-solid--badge-check text-EXPONDO-secondary-medium" />
              <span><b>{{ $t('extra-guarantee.details.b1') }}</b> {{ $t('extra-guarantee.details.b2') }}</span>
            </li>
            <li class="flex gap-2">
              <span class="mt-0.25 text-lg shrink-0 iconify fa-pro-solid--badge-check text-EXPONDO-secondary-medium" />
              <span><b>{{ $t('extra-guarantee.details.c1') }}</b> {{ $t('extra-guarantee.details.c2') }}</span>
            </li>
          </ul>
          <br>
          <i18n-t
          keypath="extra-guarantee.details.e"
          tag="p">
            <template #guaranteepolicy>
              <CustomLink
                :text="$t('extra-guarantee.details.guarantee-policy-link-text')"
                :url="$t('/premium-guarantee/')"
                blank
              />
            </template>
          </i18n-t>
        </div>
      </CartSection>
    </div>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'ExtraGuaranteeInner',

  props: {
    extraGuaranteeSku: {
      type: String,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    productImage: {
      type: String,
      required: true,
    },
  },
  emits: ['update:selectedOption'],
});

</script>

<style lang="scss" scoped>
.extra-guarantee {
  &__conditions {
    li {
      margin-left: 1.5rem;
    }
  }
}
</style>
